<template>
    <div
        class="visualization visualization-payment-days"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <div v-show="!showDetails" class="row">
            <div class="col-sm-3">
                <ol class="breadcrumb breadcrumb-vertical">
                    <li
                        class="breadcrumb-item"
                        v-for="(b, i) in breadcrumb"
                        :key="i"
                        :class="{ active: i === breadcrumb.length - 1 }"
                        @click.prevent="pop()"
                    >
                        <div class="title">{{ b.type }}</div>
                        <div>
                            <a v-if="i !== breadcrumb.length - 1" href="#">{{
                                b.label
                            }}</a>
                            <span v-else>{{ b.label }}</span>
                        </div>
                        <div class="amount">{{ moneyFormatter(b.sum) }}</div>
                        <div class="percentage">
                            {{ numeral(b.ratio).format('0.00%') }}
                        </div>
                    </li>
                </ol>
            </div>
            <div class="col-sm-9">
                <sunburst-chart
                    class="chart"
                    ref="sunburstChart"
                    :data="data"
                    :dimensions="dimensions"
                    :labels="labels"
                    :breadcrumb.sync="breadcrumb"
                    @detail-clicked="detailClicked"
                ></sunburst-chart>
            </div>
        </div>
        <div v-show="showDetails">
            <a href="#" @click.prevent="details = null">< Volver al gráfico</a>
            <expenses-detail-visualization
                :where="details"
                ref="detailViz"
            ></expenses-detail-visualization>
        </div>
    </div>
</template>
<style lang="scss">
.visualization-payment-days {
    .chart {
        max-width: 600px;
    }
}
</style>
<script>
import * as d3 from 'd3';
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import moneyFormatter from '../../Methods/MoneyFormatter';
import SunburstChart from '../Charts/Sunburst';
import ExpensesDetailVisualization from './ExpensesDetail';

export default {
    data: function() {
        return {
            loading: false,
            data: [],
            breadcrumb: [],
            details: null,
            dimensions: {
                ordinal: ['dias_de_pago_cat', 'partida', 'capitulo', 'area']
            },
            labels: {
                dias_de_pago_cat: {
                    '30': '30 días',
                    '60': '60 días',
                    '90': '90 días',
                    '180': '180 días',
                    '365': '365 días',
                    '365+': 'Más de 365 días'
                } /*,
                partida: {},
                capitulo: {},
                area: {}*/
            },
            url:
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify([
                    'dias_de_pago_cat',
                    'partida',
                    'capitulo',
                    'area'
                ]) +
                '&where-not=' +
                JSON.stringify({ dias_de_pago_cat: null })
        };
    },
    components: {
        SunburstChart,
        ExpensesDetailVisualization
    },
    computed: {
        showDetails() {
            return this.details !== null;
        }
    },

    methods: {
        moneyFormatter,
        numeral,
        detailClicked: function(node) {
            const segments = node.id.split('/');
            this.details = {
                dias_de_pago_cat: segments[0],
                partida: segments[1],
                capitulo: segments[2],
                area: segments[3]
            };
        },
        pop: function() {
            this.$refs.sunburstChart.pop();
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;

                this.data = response.data;

                /*
                response.data.forEach(d => {
                    this.labels.partida[d.partida] = d.nombre_partida;
                    this.labels.capitulo[d.capitulo] = d.nombre_capitulo;
                    this.labels.area[d.area] = d.nombre_area;
                });
                */
            });
        }
    },
    mounted: function() {
        this.refreshData();
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/PaymentDays.vue